<div style="margin-bottom: 7px">
  <div style="position: relative">
    <div #paymentRequestButton class="applePayButton"></div>

    <div
      *ngIf="!checkboxesForm.valid"
      (click)="onApplePayButtonClick()"
      style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; cursor: pointer"
    ></div>
  </div>

  <div class="secure-payment-banner">
    <svg class="lock-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" fill="currentColor"/>
      <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      <circle cx="12" cy="16" r="1" fill="#7c6adb"/>
    </svg>
    <h2 class="banner-title">Secure Payment</h2>
    <p class="banner-description">
      Your information is protected with 256-bit SSL<br>encryption
    </p>
  </div>

  <div class="loading-notify loading-notify-mobile" *ngIf="loading">
    {{ "disclosure.your_payment_is_processing" | translate }}
  </div>

  <app-stripe-payment-form
    [totalPayable]="totalPayable"
    [config]="formConfig"
    [isAssurant]="isAssurant"
    [loading]="loading"
    [externalLoadingControl]="true"
    [kioskChecked]="kioskRules ? kioskRulesControl.value: true"
    [disclosureAgreementChecked]="isAssurant ? disclosureAgreementControl.value : true"
    [receiveDocumentsByEmailChecked]="isAssurant ? receiveDocumentsByEmailControl.value : true"
    [termsAccepted]="termsAccepted"
    [checkboxError]="checkboxError$ | async"
    (formSubmit)="onFormSubmit($event)"
    (applePayComplete)="onFormSubmit($event)"
    stripeFormType="resident-payment"
    (formCancel)="decline()"
    (formError)="onFormError($event)">
    <div [formGroup]="checkboxesForm">
      <mat-checkbox
        formControlName="termsAgreement"
        color="primary"
        labelPosition="after"
        class="mat-checkbox-confirm"
        data-testid="terms_agreement"
      >
        <span (click)="onAgreementTextClick($event)" [innerHTML]="'form.checkout_agree_to_terms' | translate"></span>
      </mat-checkbox>

      <mat-checkbox
        formControlName="disclosureAgreement"
        color="primary"
        labelPosition="after"
        data-testid="disclosure_agreement"
        class="brookfield-rules"
        *ngIf="isAssurant"
      >
        By clicking “Purchase,” I acknowledge that I have read and understand all applicable
        <a href="#" class="text-decoration--underline" (click)="onAssurantDisclosureTextClick($event, AssurantLegalContentType.StateDisclosure)">regulatory notice</a>,
        <a href="#" class="text-decoration--underline" (click)="onAssurantDisclosureTextClick($event, AssurantLegalContentType.FraudNotice)">fraud notices</a>,
        <a href="#" class="text-decoration--underline" (click)="onAssurantDisclosureTextClick($event, AssurantLegalContentType.NoticeOfCancellation)">notice of cancellation</a>,
        <a href="#" class="text-decoration--underline" (click)="onAssurantDisclosureTextClick($event, AssurantLegalContentType.RecurringPaymentAuthorization)">recurring payment authorization</a>, and
        <a href="#" class="text-decoration--underline" (click)="onAssurantDisclosureTextClick($event, AssurantLegalContentType.EBC)">electronic business consent</a>
      </mat-checkbox>

      <mat-checkbox
        formControlName="kioskRules"
        color="primary"
        labelPosition="after"
        class="brookfield-rules"
        *ngIf="kioskRules"
      >
        By completing this transaction, you are agreeing to become a member of the risk purchasing group, Brookfield
        Properties Tenant Insurance Program LLC RPG (the "RPG"), as more fully described in the Operating Agreement and
        Joinder. Membership in the RPG shall be on a Class B basis and is limited to providing the right to apply for and
        purchase insurance offered by the RPG. This membership does not provide any rights to direct the management of the
        RPG or share in the profits, losses, or other financial interests of the RPG. Completing this transaction shall
        serve as the execution of the Joinder as of the date of the submission.
      </mat-checkbox>

      <mat-checkbox
        *ngIf="isAssurant"
        formControlName="receiveDocumentsByEmail"
        color="primary"
        labelPosition="after"
      >
        I’d like to receive all policy and billing documents by email.
      </mat-checkbox>
    </div>
    <div id="card-element" #cardElement></div>
  </app-stripe-payment-form>

  <p class="has-text-danger">{{ cardErrors }}</p>
</div>
<hr />

<div class="loading-notify loading-notify-desktop" *ngIf="loading">
  {{ "disclosure.your_payment_is_processing" | translate }}
</div>
<pre *ngIf="confirmation" style="max-width: 500px">
  {{ confirmation | json }}
</pre>
